<template>
  <div class="ProjectInfo" v-loading="loading">
    <div style="width: 260px; height: calc(100vh - 70px)">
      <div
        style="
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0 20px;
        "
      >
        <el-button
          style="
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
          "
          type="primary"
          @click="$router.go(-1)"
        >
          <span style="margin-left: 10px"
            ><i class="el-icon-back" style="margin-right: 10px"></i> 后退前页</span
          >
        </el-button>
      </div>
      <el-menu
        :default-active="activeName"
        class="el-menu-vertical-demo"
        ref="menuTree"
        router
      >
        <el-menu-item :index="'/ProjectInfo/ProjectAll?id=' + this.$route.query.id">
          <i class="el-icon-monitor"></i>
          <span slot="title">工作台</span>
        </el-menu-item>

        <el-submenu v-for="item in MenuTteeData" :key="item.Id" :index="item.Id">
          <template slot="title">
            <i class="icon-gongyingshang1 icon" style="margin-right: 2px"></i>
            <span style="display: inline-block; white-space: normal; flex: 1">{{
              item.title
            }}</span>
          </template>
          <el-menu-item v-for="ele in item.children" :key="ele.Id" :index="ele.path">
            <i
              :class="
                ele.Type == 4 || ele.Type == 5 || ele.Type == 6
                  ? 'el-icon-edit-outline'
                  : 'el-icon-document'
              "
            ></i>

            <span style="display: inline-block; white-space: normal; flex: 1">{{
              ele.title
            }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <div class="tabsBut">
        <el-tabs type="border-card" v-model="menuValue" @tab-click="menuChange">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="乙供" name="1"></el-tab-pane>

          <el-tab-pane label="甲供" name="3"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div style="width: calc(100% - 260px); height: calc(100vh - 70px); overflow: hidden">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuValue: 0,
      token: "",
      loading: false,
      ProjectInfo: {},
      MenuTteeData: [],
      domList: [
        {
          name: "info",
          label: "项目信息",
          labelColor: "#409EFF",
          icon: "el-icon-notebook-2",
          IconColor: "#409EFF",
          path: "Info",
        },
        {
          name: "ProjectClass",
          label: "项目设备分类",
          labelColor: "#C06BC1",
          icon: "el-icon-s-grid",
          IconColor: "#C06BC1",
          path: "ProjectClass",
        },
        {
          name: "Facility",
          label: "资料模板",
          labelColor: "#C06BC1",
          icon: "el-icon-s-grid",
          IconColor: "#C06BC1",
          path: "Facility",
        },
        {
          name: "TempSupplier",
          label: "项目供应商",
          IconColor: "#BFA170",
          icon: "el-icon-s-management",
          labelColor: "#BFA170",
          path: "TempSupplier",
        },
        {
          name: "File",
          label: "项目云盘",

          icon: "el-icon-folder",
          labelColor: "#70BABF",
          IconColor: "#70BABF",
          path: "File",
        },
        // {
        //   name: 'ProjectStatistic',
        //   label: '统计信息',
        //   icon: 'el-icon-s-order',
        //   labelColor: '#67C23A',
        //   IconColor: '#67C23A',
        //   path: 'ProjectStatistic',
        // },
        {
          name: "ProjectOverview",
          label: "项目统计总览",
          icon: "el-icon-s-order",
          labelColor: "#67C23A",
          IconColor: "#67C23A",
          path: "ProjectOverview",
        },
        // {
        //   name: "DeviceStatistic",
        //   label: "设备统计信息",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "DeviceStatistic",
        // },
        // {
        //   name: "SupplierStatistic",
        //   label: "供应商统计信息",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "SupplierStatistic",
        // },

        {
          name: "BimModel",
          label: "BIM模型",
          icon: "el-icon-office-building",
          labelColor: "#DCDFE6",
          IconColor: "#DCDFE6",
          path: "BimModel",
        },
        // {
        //   name: "Spare",
        //   label: "配件清单",

        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "Spare",
        // },
        // {
        //   name: "ScheduleDocument",
        //   label: "设备资料清单",
        //   icon: "el-icon-s-order",
        //   labelColor: "#67C23A",
        //   IconColor: "#67C23A",
        //   path: "ScheduleDocument",
        // },
        // {
        //   name: "Schedule",
        //   label: "设备审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "Schedule",
        // },
        // {
        //   name: "ProjectDocument",
        //   label: "项目资料审核",
        //   icon: "el-icon-edit-outline",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        //   path: "ProjectDocument",
        // },
        // {
        //   name: "TeamAuditDocument",
        //   label: "供应商审核",
        //   icon: "el-icon-edit-outline",
        //   path: "TeamAuditDocument",
        //   labelColor: "#E6A23C",
        //   IconColor: "#E6A23C",
        // },
        // {
        //   name: "ProjectInspect",
        //   label: "项目完结检查",
        //   icon: "el-icon-s-claim",
        //   labelColor: "#F56C6C",
        //   IconColor: "#F56C6C",
        //   path: "ProjectInspect",
        // },
      ],
    };
  },
  props: {},
  components: {},
  methods: {
    menuChange() {
      window.sessionStorage.setItem("menuValue", this.menuValue);
      if (this.$route.path == "/ProjectInfo/ProjectAll") {
        this.getMenuTtee(this.$route.query.id, this.menuValue);
      } else {
        this.$router.replace("/ProjectInfo/ProjectAll?id=" + this.$route.query.id);
        this.getMenuTtee(this.$route.query.id, this.menuValue);
      }
    },
    async getProjectInfo(id) {
      this.loading = true;
      await this.$http
        .post("/Base_ProjectWork/Base_Project/GetTheData", { id })
        .then((res) => {
          this.loading = false;
          if (res.Success) {
            this.ProjectInfo = res.Data;
            window.localStorage.setItem("ProjectName", res.Data.Name);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getMenuTtee(id, Type) {
      this.loading = true;
      await this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectSupDeviceTypeTree?ProjectId=${id}&Type=${Type}`,
          {}
        )
        .then(async (res) => {
          this.loading = false;
          if (res.Success) {
            let Data = res.Data.filter((item) => {
              return item.Type == 2;
            });
            Data.forEach((ele) => {
              ele.children?.forEach((item) => {
                const baseParams = `id=${this.$route.query.id}&devId=${item.Id}&ParentId=${item.ParentId}&SupplyType=${item.SupplyType}`;

                if (item.Type === 3) {
                  //设备审核
                  item.path = `/ProjectInfo/ProjectDeviceAudit?${baseParams}`;
                } else if (item.Type === 4) {
                  //供应商资质审核
                  item.path = `/ProjectInfo/TeamAuditDocument?${baseParams}`;
                } else if (item.Type === 5) {
                  //项目资料审核
                  item.path = `/ProjectInfo/ProjectDocument?${baseParams}`;
                } else if (item.Type === 6) {
                  //配件审核
                  item.path = `/ProjectInfo/SparesReview?${baseParams}`;
                } else if (item.Type === 7) {
                  //统计
                  item.path = `/ProjectInfo/SupplierStatistics?${baseParams}`;
                }
              });
            });
            this.MenuTteeData = [...Data];
            // console.log(this.MenuTteeData);

            // // this.ProjectInfo = res.Data;
            // let n = this.$route;
            // let index = this.whiteList.findIndex((item) => {
            //   return n.path.indexOf(item) > -1;
            // });
            // if (index > -1) {
            //   // this.activeName = "/ProjectInfo/ProjectAll";
            //   this.activeName = this.whiteList[index];
            // } else {
            //   await this.$nextTick(() => {
            //     if (window.localStorage.getItem("itemType")) {
            //       let item = JSON.parse(window.localStorage.getItem("itemType"));
            //       this.$refs.menuTree.open(
            //         JSON.stringify({
            //           Id: item.prId,
            //           Type: 2,
            //           prId: item.prId,
            //         })
            //       );
            //       setTimeout(() => {
            //         this.activeName = window.localStorage.getItem("itemType");
            //       }, 1);
            //     }
            //     console.log(this.activeName, "this.activeName this.activeName ");
            //   });
            //   // this.activeName = n.path;
            // }
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
  },
  mounted() {},
  async created() {
    if (window.sessionStorage.getItem("menuValue")) {
      this.menuValue = window.sessionStorage.getItem("menuValue");
    }
    await this.getProjectInfo(this.$route.query.id);
    this.getMenuTtee(this.$route.query.id, this.menuValue);
  },
  computed: {
    activeName() {
      const { path, query } = this.$route;
      console.log(path, "pathpath");
      let obj = this.domList.find((item) => {
        return path.indexOf("/ProjectInfo/" + item.path) > -1;
      });
      console.log(obj, "indeindexindexindexindexindexindexindexx");
      if (obj) {
        return "/ProjectInfo/ProjectAll?id=" + this.$route.query.id;
      }
      // 按固定顺序拼接参数
      const params = [];
      if (query.id) params.push(`id=${query.id}`);
      if (query.devId) params.push(`devId=${query.devId}`);
      if (query.ParentId) params.push(`ParentId=${query.ParentId}`);
      if (query.SupplyType) params.push(`SupplyType=${query.SupplyType}`);
      return params.length ? `${path}?${params.join("&")}` : path;
    },
  },
  updated() {
    console.log(this.MenuTteeData);
    console.log(this.activeName, "this.activeNamethis.activeName");
  },
  watch: {
    $route: {
      handler(n, o) {},
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.ProjectInfo {
  width: 100%;
  display: flex;
  height: 100%;
}
.el-menu-vertical-demo {
  height: calc(100% - 90px);
  overflow-y: auto;
  overflow-x: hidden;
}
::v-deep .el-menu-item,
.el-submenu__title {
  line-height: 1.2;
  display: flex;
  align-items: center;
}
::v-deep .el-submenu__title {
  line-height: 1.2 !important;
  display: flex;
  align-items: center;
}
.el-menu-item,
.el-submenu__title ::v-deep .el-submenu__title {
  display: flex;
  align-items: center;
}
::v-deep .el-menu-item {
  display: flex;
  align-items: center;
}
.tabsBut {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-radio-button__inner {
  width: 100%;
}
::v-deep .tabsBut {
  .el-tabs__content {
    display: none;
  }
  .el-tabs--border-card {
    width: 100%;
    box-shadow: none;
    .el-tabs__header {
      width: 100%;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .el-tabs__item {
    width: 30%;
    padding: 0 !important;
    text-align: center;
  }
}
</style>
